var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5234 0.130859H2.77344C1.71875 0.130859 0.898438 0.990234 0.898438 2.00586V15.7559C0.898438 16.8105 1.71875 17.6309 2.77344 17.6309H8.125V11.6934H5.66406V8.88086H8.125V6.77148C8.125 4.34961 9.57031 2.98242 11.7578 2.98242C12.8516 2.98242 13.9453 3.17773 13.9453 3.17773V5.56055H12.7344C11.5234 5.56055 11.1328 6.30273 11.1328 7.08398V8.88086H13.8281L13.3984 11.6934H11.1328V17.6309H16.5234C17.5391 17.6309 18.3984 16.8105 18.3984 15.7559V2.00586C18.3984 0.990234 17.5391 0.130859 16.5234 0.130859Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ccee4a6bf5ed5d963888f836688a1a78.svg";
export { ForwardRef as ReactComponent };